import React from 'react';
import { Container, Typography, Box, Grid, Paper, Button } from '@mui/material';
import { motion } from 'framer-motion';
import Layout from './Layout';
import { colors } from '../colors';

const Solutions = () => {
    return (
        <Layout>
            {/* Blue Banner */}
            <Box
                sx={{
                    backgroundColor: colors.primaryBannerBlue,
                    color: 'white',
                    padding: { xs: '5px 0', sm: '10px 0' }, // Responsive padding
                    textAlign: 'center',
                    fontSize: { xs: '1rem', sm: '1.2rem' },
                    fontWeight: '500',
                }}
            >
                SOLUTIONS
            </Box>
            <Container maxWidth="lg" sx={{ mt: 5 }}>
                {/* Hero Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5 }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #F8C7C3, #F4D8C2)',  // Softer coral and light brown gradient
                            color: '#333',  // Dark text for contrast
                            padding: '50px 20px',
                            textAlign: 'center',
                            borderRadius: '15px', // More rounded edges
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',  // Softer shadow for a light theme
                        }}
                    >
                        <Typography
                            variant="h3"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',  // Bold text for the title
                                letterSpacing: '1px',  // Slightly spaced letters for a more elegant feel
                                color: colors.racineRedDark,  // Coral red for the title to stay within your theme
                            }}
                        >
                            Our Solutions
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                color: colors.primaryApplicationText,  // Softer gray color for the subtitle
                                fontWeight: '300',  // Light font weight for a softer effect
                                maxWidth: '700px',  // Limit width for better readability on large screens
                                margin: '0 auto',  // Center the text block
                                mt: 2,
                            }}
                        >
                            Discover the best-in-class solutions we offer to help you achieve your goals.
                        </Typography>
                    </Box>
                </motion.div>



                {/* Solutions Cards */}
                <motion.div
                    initial={{ x: '-100vw' }}
                    animate={{ x: 0 }}
                    transition={{ type: 'spring', stiffness: 120 }}
                >
                    <Box mt={8}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={4}
                                    sx={{
                                        padding: '30px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },  // Hover effect
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <Typography variant="h5" sx={{ color: colors.racineRedDark, fontWeight: 'bold' }}>
                                        Data Analytics
                                    </Typography>
                                    <Typography sx={{ mt: 2, color: '#333' }}>
                                        Use our advanced data analytics tools to gain insights into your data and make smarter decisions.
                                    </Typography>
                                    <Button sx={{ mt: 3, color: colors.racineRedDark }} variant="outlined">
                                        Learn More
                                    </Button>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={4}
                                    sx={{
                                        padding: '30px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <Typography variant="h5" sx={{ color: colors.racineRedDark, fontWeight: 'bold' }}>
                                        Survey Design
                                    </Typography>
                                    <Typography sx={{ mt: 2, color: '#333' }}>
                                        Design and customize your surveys with our intuitive survey creation platform.
                                    </Typography>
                                    <Button sx={{ mt: 3, color: colors.racineRedDark }} variant="outlined">
                                        Learn More
                                    </Button>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={4}
                                    sx={{
                                        padding: '30px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <Typography variant="h5" sx={{ color: colors.racineRedDark, fontWeight: 'bold' }}>
                                        Global Outreach
                                    </Typography>
                                    <Typography sx={{ mt: 2, color: '#333' }}>
                                        Expand your reach with our global survey distribution and data collection tools.
                                    </Typography>
                                    <Button sx={{ mt: 3, color: colors.racineRedDark }} variant="outlined">
                                        Learn More
                                    </Button>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Box>
                </motion.div>

                {/* Call-to-Action Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5 }}
                >
                    <Box textAlign="center" mt={10}>
                        <Typography variant="h5" sx={{ color: colors.racineRedDark }}>
                            Ready to explore our solutions?
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: colors.racineRedDark,
                                color: 'white',
                                padding: '10px 20px',
                                marginTop: '20px',
                                '&:hover': { backgroundColor: '#D0453E' },
                            }}
                        >
                            Get Started
                        </Button>
                    </Box>
                </motion.div>
            </Container>
        </Layout>
    );
};

export default Solutions;
